import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const logoutAPI = async () => {
  return axios.post(
    `${config.api.base_url}auth/logout`,
    {},
    {
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: getToken(),
      },
    }
  );
};

export default logoutAPI;
